// import React, { useEffect, useRef, useState } from 'react';

// import { Table, Card, Button, Spin, message } from 'antd';
// import _ from 'lodash';
// import GeoJSON from 'ol/format/GeoJSON';
// import handlebars from 'handlebars/dist/handlebars.min.js';

// import { getSiteValueLocations, getSiteValueInfo, getAttachmentSignedUrl, getComments, getActivities } from './actions'
// import { zoomToPoints, getMapInstance, createDraftFeatureLayer, addLayerSwitcher, getPointStyleFunction } from '../utils/map-utils';
// import { SITE_VALUE_TYPES, SITE_VALUE_RECORD_TYPE } from '../utils/constants';
// import { resolveTemplate, formatDateTimeToDisplay, formatDateToDisplay } from '../utils/common-utils'
// import { RecordViewerModal } from './RecordViewerModal';

// export const AudubonSiteValuesMapView = (props) => {

//     const [isLoading, setIsLoading] = useState(false);
//     const [selectedSiteValueId, setSelectedSiteValueId] = useState();
//     const [orgId, setOrgId] = useState();
//     const [orgUnitId, setOrgUnitId] = useState();
//     const [certificate, setCertificate] = useState();
//     const [recordViewInner, setRecordViewInner] = useState('<div/>');
//     const [recordViewerVisible, setRecordViewerVisible] = useState(false);

//     const [map, setMap] = useState();
//     const [siteValuesList, setSiteValuesList] = useState();

//     const mapRef = useRef();

//     useEffect(() => {
//         setOrgId(props.orgId);
//         setOrgUnitId(props.orgUnitId);
//         setCertificate(props.certificate)
//         // load locations
//         loadLocations(props.orgId, props.orgUnitId, props.certificate);
//     }, [props.orgId, props.orgUnitId, props.certificate]);

//     const loadLocations = async (orgId, orgUnitId, certificate) => {
//         const locations = await getSiteValueLocations(orgId, orgUnitId, SITE_VALUE_RECORD_TYPE.AUDUBON,  certificate);
//         setSiteValuesList(locations);
//         const locationDataMap = locations.reduce((locationDataMap, location) => {
//             const type = location.type;
//             location.geom = JSON.parse(location.geom);
//             if (!locationDataMap[type]) {
//                 locationDataMap[type] = [];
//             }
//             locationDataMap[type].push(location);
//             return locationDataMap;
//         }, {});
//         setIsLoading(false);

//         // draw map
//         const draftFeatureLayer = createDraftFeatureLayer(getPointStyleFunction);
//         const airFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Air');
//         const infrastructureFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Infrastructure');
//         const energyFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Energy');
//         const managedTurfAreasFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Managed Turf Areas');
//         const vegetationAndHabitatFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Vegetation and Habitat');
//         const wasteFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Waste');
//         const waterFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Water');
//         const wildlifeFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Wildlife');
//         const healthAndSafetyLayerFeatureLayer = createDraftFeatureLayer(getPointStyleFunction, 'Health and Safety');

//         if (!map) {
//             var newMap = getMapInstance({
//                 draftFeaturesLayer: draftFeatureLayer,
//                 mapRef: mapRef
//             });
//             setMap(newMap);

//             newMap.addLayer(wildlifeFeatureLayer);
//             newMap.addLayer(waterFeatureLayer);
//             newMap.addLayer(wasteFeatureLayer);
//             newMap.addLayer(vegetationAndHabitatFeatureLayer);
//             newMap.addLayer(managedTurfAreasFeatureLayer);
//             newMap.addLayer(infrastructureFeatureLayer);
//             newMap.addLayer(healthAndSafetyLayerFeatureLayer);
//             newMap.addLayer(energyFeatureLayer);
//             newMap.addLayer(airFeatureLayer);
//             addLayerSwitcher(newMap);
//             zoomToPoints(newMap, draftFeatureLayer);

//             newMap.on('click', async(evt) => {
//                 const f = newMap.forEachFeatureAtPixel(
//                     evt.pixel, (ft, layer) => { return ft; }
//                 );

//                 if (f) {
//                     if (!f.get('type')) return; // new ones, just skip
//                     await downloadReviewRecordURL(orgId, orgUnitId, certificate, f.get('id'));
//                 }
//             });
//         }
//         addFeaturesToLayer('air', airFeatureLayer, locationDataMap);
//         addFeaturesToLayer('infrastructure', infrastructureFeatureLayer, locationDataMap);
//         addFeaturesToLayer('energy', energyFeatureLayer, locationDataMap);
//         addFeaturesToLayer('water', waterFeatureLayer, locationDataMap);
//         addFeaturesToLayer('waste', wasteFeatureLayer, locationDataMap);
//         addFeaturesToLayer('wildlife', wildlifeFeatureLayer, locationDataMap);
//         addFeaturesToLayer('managed_turf_areas', managedTurfAreasFeatureLayer, locationDataMap);
//         addFeaturesToLayer('vegetation_and_habitat', vegetationAndHabitatFeatureLayer, locationDataMap);
//         addFeaturesToLayer('health_and_safety', healthAndSafetyLayerFeatureLayer, locationDataMap);
//     }


//     const addFeaturesToLayer = (type, layer, dataMap) => {
//         const geojson = new GeoJSON();
//         const source = layer.getSource();
//         source.clear();
//         const locations = dataMap[type] || [];
//         locations.forEach(location => {
//             if (!_.isEmpty(location.geom)) {
//                 let features = geojson.readFeatures(location.geom);
//                 features = features.map(f => {
//                     f.set('title', location.title);
//                     f.set('type', type);
//                     f.set('date', f.get('date') || location.created_at);
//                     f.set('id', location.site_value_id);
//                     return f;
//                 });
//                 source.addFeatures(features);
//                 source.refresh();
//             }
//         });
//     }

//     const setRecordViewInnerData = async (data) => {
//         const template = await resolveTemplate(`reports/site-values/location_report_en.html`);
//         const compiledTemplate = handlebars.compile(template);
//         const input = compiledTemplate(data);
//         setRecordViewInner(input);
//     }

//     const getTumbnail = (key, downloadUrl) => {
//         const extention = key.split('.').pop().toLowerCase();
//         switch(extention){
//             case ("jpg"):
//             case ("jpeg"):
//             case ("png"):
//                 return downloadUrl;
//             case ("pdf"):
//                 return "/icons/thumbnails/pdf.png";
//             default:
//                 return "/icons/thumbnails/file.png";
//         }

//     }

//     const getRecordViewerData = async (orgId, orgUnitId, certificate, siteValueId) => {

//         const [siteValueInfo, comments, activities] = await Promise.all([
//             getSiteValueInfo(orgId, orgUnitId, siteValueId, certificate),
//             getComments(orgId, siteValueId),
//             getActivities(orgId, siteValueId)
//           ]);

//         const { title, type, description, created_at, attachments, geom } =  siteValueInfo;
//         const parsedGeom = JSON.parse(geom);

//         let locationAttachments = parsedGeom.type === 'Feature' ?  parsedGeom.properties.attachments :  parsedGeom.features[0].properties.attachments;

//         let attachmentObjs = [];
//         if (attachments) {
//             const proms = attachments.map(async (key) => {
//                 const attachment = await getAttachmentSignedUrl(orgId, siteValueId, key);
//                 if (attachment) {
//                     const downloadUrl = attachment.url;
//                     const im = {
//                         downloadUrl : downloadUrl,
//                         thumbnailUrl :getTumbnail(key, downloadUrl),
//                         name : key
//                     }
//                     return im;
//                 }
//             });
//             attachmentObjs = await Promise.all(proms);
//         }

//         const locationAttachmentObjs = attachmentObjs.filter(x => locationAttachments.includes(x.name) );
//         const generalAttachments = attachmentObjs.filter(x => !locationAttachments.includes(x.name) );

//         if(comments){
//             comments.map((comment) => {
//                 comment.added = formatDateTimeToDisplay(comment.createdAt)
//                 return comment;
//             });
//         }

//         if(activities){
//             activities.map((activity) => {
//                 activity.added = formatDateTimeToDisplay(activity.createdAt)
//                 return activity;
//             });
//         }

//         const response = {
//             siteValue: {
//                 title,
//                 type : SITE_VALUE_TYPES.find(val => val.key === type).value,
//                 description,
//                 createdAt: formatDateTimeToDisplay(created_at)
//             },
//             attachments: generalAttachments,
//             locationAttachments : locationAttachmentObjs,
//             comments,
//             activities
//         };

//         return response;
//     }

//     const downloadReviewRecordURL = async (orgId, orgUnitId, certificate, siteValueRecordId) => {

//         try {
//             setSelectedSiteValueId(siteValueRecordId);
//             setIsLoading(true);
//             setRecordViewerVisible(true);
//             const data = await getRecordViewerData(orgId, orgUnitId, certificate, siteValueRecordId);
//             await setRecordViewInnerData(data);
//             setIsLoading(false);
//             setSelectedSiteValueId();
//         } catch (e) {
//             console.error(e)
//             setIsLoading(false);
//             message.error('Error in getting document content. Retry later');

//         }

//     }

//     const columns = [{
//         title: 'Name',
//         dataIndex: 'title',
//         render: (_, record) => record.title
//     },
//     {
//         title: 'Date Added',
//         dataIndex: 'created_at',
//         render: (_, record) => formatDateToDisplay(record.created_at)
//     },
//     {
//         title: 'Type',
//         dataIndex: 'type',
//         render: (_, record) => SITE_VALUE_TYPES.find(val => val.key === record.type).value
//     },
//     {
//         title: '',
//         dataIndex: '',
//         render: (_, record) =>
//         (<Button type="link" onClick={() => { downloadReviewRecordURL(orgId, orgUnitId, certificate, record.site_value_id)}}
//             icon={
//                 isLoading && selectedSiteValueId === record.site_value_id ? (
//                     <Spin size="small"
//                     />
//                 ) : null
//             }> &nbsp;View </Button>)


//     }]

//     return (
//         <Card title="S. M. A. R. T. Map">

//             {
//                 recordViewerVisible && <RecordViewerModal
//                     onClose={() => setRecordViewerVisible(false)}
//                     reportData={recordViewInner}
//                     isLoading={isLoading}
//                     reportName = "site_value_report"
//                 />
//             }
//             <div>
//                 <React.Fragment>
//                     <div className='epar__hazard'>
//                         <div className="pure-g epar__content__taskbar">
//                             <div className="pure-u-1-3">
//                             </div>
//                             <div className="pure-u-2-3">
//                             </div>
//                         </div>

//                         <div className="pure-g epar__tasklist">
//                             <div className="pure-u-1">
//                                 <div ref={mapRef} />
//                             </div>
//                         </div>

//                         <div className="pure-g epar__content__taskbar epar__hazard__map__legend">
//                             {SITE_VALUE_TYPES.map(site =>
//                             (
//                                 <div key={site.key} className="pure-u-1-6">
//                                     {/* <img src={`/icons/site-value/${site.icon}`} alt={site.value} /> {site.value} */}
//                                     <img src={`https://eparhawk.com/assets/site-value-icons/${site.icon}`} alt={site.value} /> {site.value}
//                                 </div>
//                             )
//                             )}

//                         </div>

//                     </div>
//                 </React.Fragment>
//                 <div className="table-wrapper" style={{ marginTop: 20 }}>
//                     <Table dataSource={siteValuesList} columns={columns} />
//                 </div>
//             </div>
//         </Card>
//     );

// }






// import React, { useEffect, useRef, useState } from 'react';

// import { Table, Card, Button, Spin, message } from 'antd';
// import _ from 'lodash';
// import GeoJSON from 'ol/format/GeoJSON';
// import { createEmpty, extend, isEmpty } from 'ol/extent';
// import handlebars from 'handlebars/dist/handlebars.min.js';

// import { getSiteValueLocations, getSiteValueInfo, getAttachmentSignedUrl, getComments, getActivities } from './actions'
// import { getMapInstance, createDraftFeatureLayer, addLayerSwitcher, getPointStyleFunction } from '../utils/map-utils';
// import { SITE_VALUE_TYPES, SITE_VALUE_RECORD_TYPE } from '../utils/constants';
// import { resolveTemplate, formatDateTimeToDisplay, formatDateToDisplay } from '../utils/common-utils'
// import { RecordViewerModal } from './RecordViewerModal';

// // Same order as the original addLayer calls
// const SITE_LAYERS = [
//     { type: 'wildlife', name: 'Wildlife' },
//     { type: 'water', name: 'Water' },
//     { type: 'waste', name: 'Waste' },
//     { type: 'vegetation_and_habitat', name: 'Vegetation and Habitat' },
//     { type: 'managed_turf_areas', name: 'Managed Turf Areas' },
//     { type: 'infrastructure', name: 'Infrastructure' },
//     { type: 'health_and_safety', name: 'Health and Safety' },
//     { type: 'energy', name: 'Energy' },
//     { type: 'air', name: 'Air' },
// ];

// const getTypeLabel = (type) => {
//     const found = SITE_VALUE_TYPES.find(val => val.key === type);
//     return found ? found.value : type;
// };

// const parseGeom = (geom) => {
//     if (typeof geom !== 'string') return geom;
//     try {
//         return JSON.parse(geom);
//     } catch (e) {
//         console.error('Invalid geom', e);
//         return null;
//     }
// };

// export const AudubonSiteValuesMapView = (props) => {

//     const [isLoading, setIsLoading] = useState(false);
//     const [selectedSiteValueId, setSelectedSiteValueId] = useState();
//     const [recordViewInner, setRecordViewInner] = useState('<div/>');
//     const [recordViewerVisible, setRecordViewerVisible] = useState(false);
//     const [siteValuesList, setSiteValuesList] = useState([]);

//     const mapRef = useRef();
//     const mapInstanceRef = useRef(null);
//     const layersRef = useRef({});
//     const clickHandlerRef = useRef();

//     // Always points at the latest props, so the map click handler is never stale
//     clickHandlerRef.current = (siteValueId) =>
//         downloadReviewRecordURL(props.orgId, props.orgUnitId, props.certificate, siteValueId);

//     // 1. Create the map and all layers ONCE
//     useEffect(() => {
//         const draftFeatureLayer = createDraftFeatureLayer(getPointStyleFunction);
//         const map = getMapInstance({
//             draftFeaturesLayer: draftFeatureLayer,
//             mapRef: mapRef
//         });

//         SITE_LAYERS.forEach(({ type, name }) => {
//             const layer = createDraftFeatureLayer(getPointStyleFunction, name);
//             layersRef.current[type] = layer;
//             map.addLayer(layer);
//         });
//         addLayerSwitcher(map);

//         map.on('click', (evt) => {
//             const f = map.forEachFeatureAtPixel(evt.pixel, (ft) => ft);
//             if (f && f.get('type') && clickHandlerRef.current) {
//                 clickHandlerRef.current(f.get('id'));
//             }
//         });

//         mapInstanceRef.current = map;

//         return () => {
//             map.setTarget(null);
//             mapInstanceRef.current = null;
//             layersRef.current = {};
//         };
//     }, []);

//     // 2. Load locations whenever the inputs change and fill the existing layers
//     useEffect(() => {
//         if (!props.orgId || !props.orgUnitId) return;
//         let cancelled = false;

//         const load = async () => {
//             try {
//                 setIsLoading(true);
//                 const response = await getSiteValueLocations(props.orgId, props.orgUnitId, SITE_VALUE_RECORD_TYPE.AUDUBON, props.certificate);
//                 if (cancelled) return;

//                 const rawLocations = Array.isArray(response) ? response : ((response && response.data) || []);
//                 const locations = rawLocations.map(location => ({ ...location, geom: parseGeom(location.geom) }));
//                 setSiteValuesList(locations);

//                 const locationDataMap = locations.reduce((acc, location) => {
//                     if (!acc[location.type]) acc[location.type] = [];
//                     acc[location.type].push(location);
//                     return acc;
//                 }, {});

//                 SITE_LAYERS.forEach(({ type }) => {
//                     addFeaturesToLayer(type, layersRef.current[type], locationDataMap);
//                 });

//                 fitToFeatures();
//             } catch (e) {
//                 console.error(e);
//                 message.error('Error in loading site values. Retry later');
//             } finally {
//                 if (!cancelled) setIsLoading(false);
//             }
//         };

//         load();
//         return () => { cancelled = true; };
//     }, [props.orgId, props.orgUnitId, props.certificate]);

//     const addFeaturesToLayer = (type, layer, dataMap) => {
//         if (!layer) return;
//         const geojson = new GeoJSON();
//         const source = layer.getSource();
//         source.clear();
//         const locations = dataMap[type] || [];
//         locations.forEach(location => {
//             if (!_.isEmpty(location.geom)) {
//                 let features = geojson.readFeatures(location.geom);
//                 features = features.map(f => {
//                     f.set('title', location.title);
//                     f.set('type', type);
//                     f.set('date', f.get('date') || location.created_at);
//                     f.set('id', location.site_value_id);
//                     return f;
//                 });
//                 source.addFeatures(features);
//             }
//         });
//     }

//     // Zoom to ALL site value layers, and skip if there is nothing to show (avoids OL assertion #25)
//     const fitToFeatures = () => {
//         const map = mapInstanceRef.current;
//         if (!map) return;

//         const extent = createEmpty();
//         Object.values(layersRef.current).forEach(layer => {
//             const source = layer.getSource();
//             if (source.getFeatures().length > 0) {
//                 extend(extent, source.getExtent());
//             }
//         });

//         if (isEmpty(extent)) return;

//         map.updateSize();
//         map.getView().fit(extent, { padding: [60, 60, 60, 60], maxZoom: 19, duration: 0 });
//     }

//     const setRecordViewInnerData = async (data) => {
//         const template = await resolveTemplate(`reports/site-values/location_report_en.html`);
//         const compiledTemplate = handlebars.compile(template);
//         const input = compiledTemplate(data);
//         setRecordViewInner(input);
//     }

//     const getTumbnail = (key, downloadUrl) => {
//         const extention = key.split('.').pop().toLowerCase();
//         switch(extention){
//             case ("jpg"):
//             case ("jpeg"):
//             case ("png"):
//                 return downloadUrl;
//             case ("pdf"):
//                 return "/icons/thumbnails/pdf.png";
//             default:
//                 return "/icons/thumbnails/file.png";
//         }
//     }

//     const getRecordViewerData = async (orgId, orgUnitId, certificate, siteValueId) => {

//         const [siteValueInfo, comments, activities] = await Promise.all([
//             getSiteValueInfo(orgId, orgUnitId, siteValueId, certificate),
//             getComments(orgId, siteValueId),
//             getActivities(orgId, siteValueId)
//         ]);

//         const { title, type, description, created_at, attachments, geom } = siteValueInfo;
//         const parsedGeom = parseGeom(geom);

//         let geomProps = null;
//         if (parsedGeom) {
//             geomProps = parsedGeom.type === 'Feature'
//                 ? parsedGeom.properties
//                 : (parsedGeom.features && parsedGeom.features[0] && parsedGeom.features[0].properties);
//         }
//         const locationAttachments = (geomProps && geomProps.attachments) || [];

//         let attachmentObjs = [];
//         if (attachments) {
//             const proms = attachments.map(async (key) => {
//                 const attachment = await getAttachmentSignedUrl(orgId, siteValueId, key);
//                 if (attachment) {
//                     const downloadUrl = attachment.url;
//                     return {
//                         downloadUrl: downloadUrl,
//                         thumbnailUrl: getTumbnail(key, downloadUrl),
//                         name: key
//                     };
//                 }
//                 return null;
//             });
//             attachmentObjs = (await Promise.all(proms)).filter(Boolean);
//         }

//         const locationAttachmentObjs = attachmentObjs.filter(x => locationAttachments.includes(x.name));
//         const generalAttachments = attachmentObjs.filter(x => !locationAttachments.includes(x.name));

//         if (comments) {
//             comments.forEach((comment) => {
//                 comment.added = formatDateTimeToDisplay(comment.createdAt)
//             });
//         }

//         if (activities) {
//             activities.forEach((activity) => {
//                 activity.added = formatDateTimeToDisplay(activity.createdAt)
//             });
//         }

//         return {
//             siteValue: {
//                 title,
//                 type: getTypeLabel(type),
//                 description,
//                 createdAt: formatDateTimeToDisplay(created_at)
//             },
//             attachments: generalAttachments,
//             locationAttachments: locationAttachmentObjs,
//             comments,
//             activities
//         };
//     }

//     const downloadReviewRecordURL = async (orgId, orgUnitId, certificate, siteValueRecordId) => {

//         try {
//             setSelectedSiteValueId(siteValueRecordId);
//             setIsLoading(true);
//             setRecordViewerVisible(true);
//             const data = await getRecordViewerData(orgId, orgUnitId, certificate, siteValueRecordId);
//             await setRecordViewInnerData(data);
//             setIsLoading(false);
//             setSelectedSiteValueId();
//         } catch (e) {
//             console.error(e)
//             setIsLoading(false);
//             setRecordViewerVisible(false);
//             message.error('Error in getting document content. Retry later');
//         }
//     }

//     const columns = [{
//         title: 'Name',
//         dataIndex: 'title',
//         render: (_, record) => record.title
//     },
//     {
//         title: 'Date Added',
//         dataIndex: 'created_at',
//         render: (_, record) => formatDateToDisplay(record.created_at)
//     },
//     {
//         title: 'Type',
//         dataIndex: 'type',
//         render: (_, record) => getTypeLabel(record.type)
//     },
//     {
//         title: '',
//         dataIndex: '',
//         render: (_, record) =>
//         (<Button type="link" onClick={() => { downloadReviewRecordURL(props.orgId, props.orgUnitId, props.certificate, record.site_value_id) }}
//             icon={
//                 isLoading && selectedSiteValueId === record.site_value_id ? (
//                     <Spin size="small" />
//                 ) : null
//             }> &nbsp;View </Button>)
//     }]

//     return (
//         <Card title="S. M. A. R. T. Map">

//             {
//                 recordViewerVisible && <RecordViewerModal
//                     onClose={() => setRecordViewerVisible(false)}
//                     reportData={recordViewInner}
//                     isLoading={isLoading}
//                     reportName="site_value_report"
//                 />
//             }
//             <div>
//                 <React.Fragment>
//                     <div className='epar__hazard'>
//                         <div className="pure-g epar__content__taskbar">
//                             <div className="pure-u-1-3">
//                             </div>
//                             <div className="pure-u-2-3">
//                             </div>
//                         </div>

//                         <div className="pure-g epar__tasklist">
//                             <div className="pure-u-1">
//                                 <div ref={mapRef} />
//                             </div>
//                         </div>

//                         <div className="pure-g epar__content__taskbar epar__hazard__map__legend">
//                             {SITE_VALUE_TYPES.map(site =>
//                             (
//                                 <div key={site.key} className="pure-u-1-6">
//                                     <img src={`https://eparhawk.com/assets/site-value-icons/${site.icon}`} alt={site.value} /> {site.value}
//                                 </div>
//                             )
//                             )}
//                         </div>

//                     </div>
//                 </React.Fragment>
//                 <div className="table-wrapper" style={{ marginTop: 20 }}>
//                     <Table dataSource={siteValuesList} columns={columns} rowKey="site_value_id" />
//                 </div>
//             </div>
//         </Card>
//     );

// }




import React, { useEffect, useRef, useState } from 'react';

import { Table, Card, Button, Spin, message, Modal } from 'antd';
import _ from 'lodash';
import GeoJSON from 'ol/format/GeoJSON';
import { createEmpty, extend, isEmpty } from 'ol/extent';

import { getSiteValueLocations, getAttachmentSignedUrl } from './actions'
import { getMapInstance, createDraftFeatureLayer, addLayerSwitcher, getPointStyleFunction } from '../utils/map-utils';
import { SITE_VALUE_TYPES, SITE_VALUE_RECORD_TYPE } from '../utils/constants';
import { formatDateToDisplay } from '../utils/common-utils'

// Same order as the original addLayer calls
const SITE_LAYERS = [
    { type: 'wildlife', name: 'Wildlife' },
    { type: 'water', name: 'Water' },
    { type: 'waste', name: 'Waste' },
    { type: 'vegetation_and_habitat', name: 'Vegetation and Habitat' },
    { type: 'managed_turf_areas', name: 'Managed Turf Areas' },
    { type: 'infrastructure', name: 'Infrastructure' },
    { type: 'health_and_safety', name: 'Health and Safety' },
    { type: 'energy', name: 'Energy' },
    { type: 'air', name: 'Air' },
];

const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp'];

const isImageFile = (name) => IMAGE_EXTENSIONS.includes((name.split('.').pop() || '').toLowerCase());

const getTypeLabel = (type) => {
    const found = SITE_VALUE_TYPES.find(val => val.key === type);
    return found ? found.value : type;
};

const parseGeom = (geom) => {
    if (typeof geom !== 'string') return geom;
    try {
        return JSON.parse(geom);
    } catch (e) {
        console.error('Invalid geom', e);
        return null;
    }
};

// Returns the properties of the first feature (or the feature itself)
const getGeomProperties = (geom) => {
    if (!geom) return null;
    if (geom.type === 'Feature') return geom.properties || null;
    if (geom.features && geom.features[0]) return geom.features[0].properties || null;
    return null;
};

export const AudubonSiteValuesMapView = (props) => {

    const [isLoading, setIsLoading] = useState(false);
    const [siteValuesList, setSiteValuesList] = useState([]);

    // Simple popup state
    const [popupVisible, setPopupVisible] = useState(false);
    const [popupLoading, setPopupLoading] = useState(false);
    const [popupData, setPopupData] = useState(null);

    const mapRef = useRef();
    const mapInstanceRef = useRef(null);
    const layersRef = useRef({});
    const clickHandlerRef = useRef();
    const locationsRef = useRef([]); // locations response, used to build the popup

    // Always points at the latest props, so the map click handler is never stale
    clickHandlerRef.current = (siteValueId) => openPopup(props.orgId, siteValueId);

    // 1. Create the map and all layers ONCE
    useEffect(() => {
        const draftFeatureLayer = createDraftFeatureLayer(getPointStyleFunction);
        const map = getMapInstance({
            draftFeaturesLayer: draftFeatureLayer,
            mapRef: mapRef
        });

        SITE_LAYERS.forEach(({ type, name }) => {
            const layer = createDraftFeatureLayer(getPointStyleFunction, name);
            layersRef.current[type] = layer;
            map.addLayer(layer);
        });
        addLayerSwitcher(map);

        map.on('click', (evt) => {
            const f = map.forEachFeatureAtPixel(evt.pixel, (ft) => ft);
            if (f && f.get('type') && clickHandlerRef.current) {
                clickHandlerRef.current(f.get('id'));
            }
        });

        map.on('pointermove', (evt) => {
            if (evt.dragging) return;

            const hit = map.forEachFeatureAtPixel(
                evt.pixel,
                (ft) => (ft.get('type') ? ft : undefined),
                { hitTolerance: 8 }
            );
            map.getTargetElement().style.cursor = hit ? 'pointer' : '';
        });

        mapInstanceRef.current = map;

        return () => {
            map.setTarget(null);
            mapInstanceRef.current = null;
            layersRef.current = {};
        };
    }, []);

    // 2. Load locations whenever the inputs change and fill the existing layers
    useEffect(() => {
        if (!props.orgId || !props.orgUnitId) return;
        let cancelled = false;

        const load = async () => {
            try {
                setIsLoading(true);
                const response = await getSiteValueLocations(props.orgId, props.orgUnitId, SITE_VALUE_RECORD_TYPE.AUDUBON, props.certificate);
                if (cancelled) return;

                const rawLocations = Array.isArray(response) ? response : ((response && response.data) || []);
                const locations = rawLocations.map(location => ({ ...location, geom: parseGeom(location.geom) }));
                setSiteValuesList(locations);
                locationsRef.current = locations;

                const locationDataMap = locations.reduce((acc, location) => {
                    if (!acc[location.type]) acc[location.type] = [];
                    acc[location.type].push(location);
                    return acc;
                }, {});

                SITE_LAYERS.forEach(({ type }) => {
                    addFeaturesToLayer(type, layersRef.current[type], locationDataMap);
                });

                fitToFeatures();
            } catch (e) {
                console.error(e);
                message.error('Error in loading site values. Retry later');
            } finally {
                if (!cancelled) setIsLoading(false);
            }
        };

        load();
        return () => { cancelled = true; };
    }, [props.orgId, props.orgUnitId, props.certificate]);

    const addFeaturesToLayer = (type, layer, dataMap) => {
        if (!layer) return;
        const geojson = new GeoJSON();
        const source = layer.getSource();
        source.clear();
        const locations = dataMap[type] || [];
        locations.forEach(location => {
            if (!_.isEmpty(location.geom)) {
                let features = geojson.readFeatures(location.geom);
                features = features.map(f => {
                    f.set('title', location.title);
                    f.set('type', type);
                    f.set('date', f.get('date') || location.created_at);
                    f.set('id', location.site_value_id);
                    return f;
                });
                source.addFeatures(features);
            }
        });
    }

    // Zoom to ALL site value layers, and skip if there is nothing to show (avoids OL assertion #25)
    const fitToFeatures = () => {
        const map = mapInstanceRef.current;
        if (!map) return;

        const extent = createEmpty();
        Object.values(layersRef.current).forEach(layer => {
            const source = layer.getSource();
            if (source.getFeatures().length > 0) {
                extend(extent, source.getExtent());
            }
        });

        if (isEmpty(extent)) return;

        map.updateSize();
        map.getView().fit(extent, { padding: [60, 60, 60, 60], maxZoom: 19, duration: 0 });
    }

    // Simple popup: built only from the locations response that is already loaded
    const openPopup = async (orgId, siteValueId) => {
        const location = locationsRef.current.find(l => l.site_value_id === siteValueId);
        if (!location) {
            message.error('Site value details not found.');
            return;
        }

        const geomProps = getGeomProperties(location.geom);
        const attachmentKeys = (geomProps && geomProps.attachments) || [];

        // Show the popup right away with the basic details
        setPopupData({
            title: location.title,
            type: getTypeLabel(location.type),
            name: (geomProps && geomProps.name) || '',
            date: formatDateToDisplay(location.created_at),
            files: []
        });
        setPopupVisible(true);

        if (attachmentKeys.length === 0) return;

        // Then load signed URLs for the attachments (a failed file is skipped)
        setPopupLoading(true);
        const files = (await Promise.all(attachmentKeys.map(async (key) => {
            try {
                const attachment = await getAttachmentSignedUrl(orgId, siteValueId, key);
                if (attachment && attachment.url) {
                    return { name: key, url: attachment.url, isImage: isImageFile(key) };
                }
            } catch (e) {
                console.error('Error getting attachment url', key, e);
            }
            return null;
        }))).filter(Boolean);

        setPopupData(prev => (prev ? { ...prev, files } : prev));
        setPopupLoading(false);
    }

    const closePopup = () => {
        setPopupVisible(false);
        setPopupData(null);
        setPopupLoading(false);
    }

    const columns = [{
        title: 'Name',
        dataIndex: 'title',
        render: (_, record) => record.title
    },
    {
        title: 'Date Added',
        dataIndex: 'created_at',
        render: (_, record) => formatDateToDisplay(record.created_at)
    },
    {
        title: 'Type',
        dataIndex: 'type',
        render: (_, record) => getTypeLabel(record.type)
    },
    {
        title: '',
        dataIndex: '',
        render: (_, record) =>
            (<Button type="link" onClick={() => openPopup(props.orgId, record.site_value_id)}>View</Button>)
    }]

    return (
        <Card title="S. M. A. R. T. Map">

            <Modal
                open={popupVisible}
                title={popupData ? popupData.title : 'Site Value'}
                footer={null}
                onCancel={closePopup}
                centered
                width={600}
                destroyOnClose
            >
                {popupData && (
                    <div style={{ display: 'flex', gap: 24, alignItems: 'flex-start', flexWrap: 'wrap' }}>

                        {/* Left: details */}
                        <div style={{ flex: '1 1 200px', minWidth: 200 }}>
                            <p><b>Type:</b> {popupData.type}</p>
                            {popupData.name && <p><b>Name:</b> {popupData.name}</p>}
                            <p><b>Date Added:</b> {popupData.date}</p>
                        </div>

                        {/* Right: images */}
                        <div style={{ flex: '0 0 280px', maxWidth: '100%' }}>
                            {popupLoading && <Spin tip="Loading images..." size="small" />}

                            {popupData.files.map(file => (
                                file.isImage ? (
                                    <a key={file.name} href={file.url} target="_blank" rel="noopener noreferrer" style={{ display: 'block', marginBottom: 12 }}>
                                        <img
                                            src={file.url}
                                            alt={file.name}
                                            style={{ width: '100%', height: 'auto', border: '1px solid #eee', display: 'block' }}
                                        />
                                    </a>
                                ) : (
                                    <a key={file.name} href={file.url} target="_blank" rel="noopener noreferrer" style={{ display: 'block', marginBottom: 12 }}>{file.name}</a>
                                )
                            ))}

                            {!popupLoading && popupData.files.length === 0 && (
                                <p style={{ color: '#999' }}>No images attached.</p>
                            )}
                        </div>
                    </div>
                )}
            </Modal>

            <div>
                <React.Fragment>
                    <div className='epar__hazard'>
                        <div className="pure-g epar__content__taskbar">
                            <div className="pure-u-1-3">
                            </div>
                            <div className="pure-u-2-3">
                            </div>
                        </div>

                        <div className="pure-g epar__tasklist">
                            <div className="pure-u-1">
                                <div ref={mapRef} />
                            </div>
                        </div>

                        <div className="pure-g epar__content__taskbar epar__hazard__map__legend">
                            {SITE_VALUE_TYPES.map(site =>
                            (
                                <div key={site.key} className="pure-u-1-6">
                                    <img src={`https://eparhawk.com/assets/site-value-icons/${site.icon}`} alt={site.value} /> {site.value}
                                </div>
                            )
                            )}
                        </div>

                    </div>
                </React.Fragment>
                <div className="table-wrapper" style={{ marginTop: 20 }}>
                    <Table dataSource={siteValuesList} columns={columns} rowKey="site_value_id" loading={isLoading} />
                </div>
            </div>
        </Card>
    );

}